import { CourseLocation } from '../enums/course-location.enum';

export const COURSE_LOCATION_LABELS: Record<CourseLocation, string> = {
  [CourseLocation.PRESENTIAL]: 'Presencial',
  [CourseLocation.ONLINE]: 'Online',
  [CourseLocation.HYBRID]: 'Híbrido'
};

export const COURSE_LOCATION_ICONS: Record<CourseLocation, string> = {
  [CourseLocation.PRESENTIAL]: 'location_on',
  [CourseLocation.ONLINE]: 'headphones',
  [CourseLocation.HYBRID]: 'hub'
};
